import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import StorePage from './pages/StorePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ProductDetailPage from './pages/ProductDetailPage';
import LegalPage from './pages/LegalPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import ScrollToTopButton from './components/ScrollToTopButton';
import { LanguageProvider } from './utils/i18n';
import { CartProvider } from './contexts/CartContext';
import GlobalAlert from './components/GlobalAlert';

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <Router>
          <Navbar />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/catalog" element={<CatalogPage />} />
              <Route path="/store" element={<StorePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/product/:slug" element={<ProductDetailPage />} />
              <Route path="/legal/:type" element={<LegalPage />} />
              <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
            </Routes>
          </Layout>
          <ScrollToTopButton />
          <Footer />
          <GlobalAlert />
        </Router>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
